<template>
<div class="container">
    <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
        <p class="col-md-4 mb-0 text-muted">Mu'eed Brown © 2023</p>
        <ul class="nav col-md-4 justify-content-end list-unstyled d-flex">
            <li class="ms-3"><a class="text-muted" href="https://www.instagram.com/mumueedo/?hl=en"><i class="fa-brands fa-instagram"></i
                ></a></li>
            <li class="ms-3"><a class="text-muted" href="https://twitter.com/hiEedo?t=yqITF9EXug_znhW8uRVD9Q&s=09"><i class="fa-brands fa-twitter"></i
                ></a></li>
            <li class="ms-3"><a class="text-muted"  href="https://m.youtube.com/c/DriftSLAYS"><i class="fa-brands fa-youtube"></i
                ></a></li>
        </ul>
    </footer>
</div>
</template>